<template>
    <loader v-if="loading"></loader>

    <div class="screen" v-else>
        <div class="travel-offers">
            <div v-for="travel_offer in all_travel_offers" v-bind:key="travel_offer.offerPhoto"
                 class="travel-offer">
                <span>{{travel_offer.name}}</span>
                <img :src="travel_offer.offerPhoto" style="border-radius: 5px; padding: 10px" width="100%"
                     height="160px">
                <div class="travel-offer-footer">
                    <div>
                        {{travel_offer.phoneNumber}}
                    </div>
                    <div>
                        {{travel_offer.date | formatData}}
                    </div>
                    <div>
                        {{travel_offer.hotelName}}
                    </div>
                </div>
                <div style="display: flex; justify-content: flex-end;width: 100%">
                    <i class="el-icon-delete" @click="onDeleteOffer(travel_offer)" style="color: red"></i>
                </div>
            </div>

        </div>


    </div>
</template>

<script>
    import TravelService from '@/common/services/travel.service'
    import mutations from "@/store/mutation_types";
    import Loader from "../common/components/loader";
    import {mapMutations, mapState} from "vuex";

    export default {
        name: 'Travel',
        components: {Loader},
        data() {
            return {
                loading: false
            }
        },
        methods: {
            ...mapMutations(['SET_TRAVEL_OFFERS']),
            onDeleteOffer(travel_offer) {
                this.loading = true;
                TravelService.deleteTravelOffers(travel_offer.id).then(() => {
                    this.$notify.success({
                        title: `Delete offer`,
                        message: `Successfully deleted offer`
                    });
                    this.getTravelOffers()
                }).catch(err => {
                    this.$notify.success({
                        title: `Delete offer`,
                        message: err.data.response.message
                    });
                })
            },

            getTravelOffers() {
                this.loading = true;
                TravelService.getTravelOffers(this.user.user_email).then(response => {
                    this[mutations.SET_TRAVEL_OFFERS](response.data)
                }).catch(error => {
                    this.$notify.error({
                        title: `Failed to travels`,
                        message: error.response.data.message
                    });
                }).finally(() => this.loading = false)
            }
        },
        computed: {
            ...mapState({
                user: state => state.user,
                all_travel_offers: state => state.travel_offers
            }),

        },
        beforeMount() {
            this.getTravelOffers();
        }
    }
</script>

<style scoped lang="scss">


    .travel-offer {
        border: 1px solid whitesmoke;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
        border-radius: 5px;
        cursor: pointer;
        -webkit-box-shadow: 0 0 5px #c7c1c1;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 20px;
        flex-direction: column;
        margin: 10px;

        .travel-offer-footer {
            display: flex;
            flex-direction: column;
            justify-content: space-between;
        }

        span {
            font-weight: 700;
            padding: 5px 0;
        }
    }


    .travel-offers {
        display: grid;
        grid-template-columns: 1fr 1fr 1fr 1fr;
        grid-gap: 10px;
        margin: 10px;


        @media screen and (max-width: 768px) {
            display: grid;
            grid-template-columns: 1fr ;
        }
    }


    .eventScheduler {
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
        bottom: 0;
        grid-area: eventScheduler;
        background-color: white;
        min-height: 52vmin;
        margin: 0 20px;
        margin-bottom: 10px;
        border-radius: 5px;
        max-width: 100%;
        overflow: hidden;
        -webkit-box-shadow: 0 0 5px #c7c1c1
    }


    .screen {
        display: grid;
        width: 100%;
        padding: 20px;
        /*height: 100%;*/
        /*height: 100vh;*/
        /*grid-gap: 10px;*/
    }
</style>
